import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, useConfirmation } from '@/contexts';

/**
 * Opens the "Equipo" upsell modal shown to solo Professional-plan vendors when
 * they tap the locked Equipo entry in the main menu. Explains the next step
 * (agregar profesional), the pricing impact of switching to the Venue plan,
 * and routes to the add-professional flow as the CTA.
 * Ágora UP ya incluye hasta 4 profesionales en la base y cobra el adicional (del 5to en adelante)
 * sin cambiar de plan, así que ve el mismo modal pero sin la venta del Plan Venue.
 */
export const useTeamUpsell = (): { openTeamUpsell: () => void } => {
  const { confirm } = useConfirmation();
  const { session } = useAuth();
  const navigate = useNavigate();

  const openTeamUpsell = useCallback(() => {
    void import('./teamUpsellDialog').then(({ showTeamUpsellDialog }) => {
      showTeamUpsellDialog({
        confirm,
        country: session?.vendor?.country,
        planName: session?.vendor?.plan_name,
        venueStaffs: session?.active_plan?.venue_staffs,
        onConfirm: () => navigate('/facturacion/agregar')
      });
    });
  }, [
    confirm,
    session?.vendor?.country,
    session?.vendor?.plan_name,
    session?.active_plan?.venue_staffs,
    navigate
  ]);

  return { openTeamUpsell };
};
